import React from 'react';

export function EntertainmentIcon({ className }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none">
      <path
        stroke="#000"
        strokeWidth="1.5"
        d="M3 4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z"
      />
      <path
        fill="#000"
        stroke="#000"
        strokeLinejoin="round"
        d="m8 7 5 3-5 3z"
      />
    </svg>
  );
}
